export default {
    login_url:"https://api.sultantaxi.kz/?a=login",
    getme_url: "https://api.sultantaxi.kz/?a=me",
    logout_url: "https://api.sultantaxi.kz/?a=logout",
    register_url:"https://api.sultantaxi.kz/?a=register",
    token_name: "_brt",
}